import { publicClient, privateClient } from './client';
import { Cart } from './Cart';

const transactionsCart = (pub: boolean) => new Cart(pub ? publicClient : privateClient);
export default transactionsCart;
